import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useForeignCurrencySupportFlag = () =>
  useBooleanFlagValue('foreign-currency-support', false);
